import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

// Stream the agent pipeline (SSE over fetch POST).
export async function runAgent(pid, prompt, onEvent) {
  const res = await fetch(`${API}/projects/${pid}/agent`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt }),
  });
  if (!res.ok || !res.body) throw new Error("Agent request failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      const line = chunk.split("\n").find((l) => l.startsWith("data: "));
      if (line) {
        try { onEvent(JSON.parse(line.slice(6))); } catch (e) { /* ignore */ }
      }
    }
  }
}

// Assemble a runnable preview document by inlining local css/js files.
export function assemblePreview(files, opts = {}) {
  const map = {};
  files.forEach((f) => (map[f.path.replace(/^\.?\//, "")] = f.content));
  let html = map["index.html"];
  if (!html) return "<html><body style='font-family:sans-serif;padding:2rem;color:#64748b'>No index.html found in this project.</body></html>";

  html = html.replace(/<link[^>]*href=["']([^"']+)["'][^>]*>/gi, (m, href) => {
    if (/^https?:|^\/\//.test(href)) return m;
    const key = href.replace(/^\.?\//, "").split("?")[0];
    return map[key] != null ? `<style>\n${map[key]}\n</style>` : m;
  });
  html = html.replace(/<script[^>]*src=["']([^"']+)["'][^>]*><\/script>/gi, (m, src) => {
    if (/^https?:|^\/\//.test(src)) return m;
    const key = src.replace(/^\.?\//, "").split("?")[0];
    return map[key] != null ? `<script>\n${map[key]}\n</script>` : m;
  });

  const bridge = `<script>
    (function(){
      function send(level,args){try{parent.postMessage({__dcode:true,level:level,msg:Array.from(args).map(function(a){try{return typeof a==='object'?JSON.stringify(a):String(a)}catch(e){return String(a)}}).join(' ')},'*')}catch(e){}}
      ['log','info','warn','error'].forEach(function(k){var o=console[k];console[k]=function(){send(k,arguments);o.apply(console,arguments)}});
      window.addEventListener('error',function(e){send('error',[e.message+' ('+(e.filename||'')+':'+e.lineno+')'])});
      window.addEventListener('unhandledrejection',function(e){send('error',['Unhandled promise: '+(e.reason&&e.reason.message||e.reason)])});
    })();
  </script>`;
  let inject = bridge;
  if (opts.dataBase) inject += `<script>window.DCODE_DATA=${JSON.stringify(opts.dataBase)};</script>`;
  if (opts.authBase) inject += `<script>window.DCODE_AUTH=${JSON.stringify(opts.authBase)};</script>`;
  if (opts.logo) inject += `<link rel="icon" href="${opts.logo}"><link rel="apple-touch-icon" href="${opts.logo}"><meta name="theme-color" content="#10B981">`;
  if (opts.extraCss) inject += `<style>\n${opts.extraCss}\n</style>`;
  if (html.includes("<head>")) html = html.replace("<head>", "<head>" + inject);
  else html = inject + html;
  return html;
}
